import { render, staticRenderFns } from "./ReportOfUnitPosition.vue?vue&type=template&id=92e2d082&"
import script from "./ReportOfUnitPosition.vue?vue&type=script&lang=ts&"
export * from "./ReportOfUnitPosition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92e2d082')) {
      api.createRecord('92e2d082', component.options)
    } else {
      api.reload('92e2d082', component.options)
    }
    module.hot.accept("./ReportOfUnitPosition.vue?vue&type=template&id=92e2d082&", function () {
      api.rerender('92e2d082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/reports/report-of-unit-position/ReportOfUnitPosition.vue"
export default component.exports